export const PAGE_NAMES = {
  digital_appointment_experience: "TR_HOMEOWNER_BOOK_ESTIMATE",
  service_quote_flow: {
    zip_step: "TR_PAGE_SERVICE",
    qna_step: "TR_SCROLL_QUESTIONS",
    is_business_step: "TR_SCROLL_IS_BUSINESS", // last "dynamic"
    extra_info_step: "TR_SCROLL_ADDINFO",
    homeowner_details: "TR_SCROLL_DETAILS",
    is_interested_step: "TR_SCROLL_INTERESTED",
    full_name_step: "TR_SCROLL_NAME",
    address_step: "TR_SCROLL_ADDRESS",
    new_address_step: "TR_SCROLL_PROPERTY_ADDRESS",
    phone_step: "TR_SCROLL_PHONE",
  },
} as const;
